import { RefTokenResponse } from '../../../models/api/slot-hisory';
import { AuthInfo, HTTPResponse } from '../../../models';
import { BaseApiService } from '../../base-api-service';
import { env } from '../../../environment';

class AuthController extends BaseApiService {

  public async refresh(refreshToken?: string): Promise<HTTPResponse<AuthInfo | null>> {
    const url = `${this.url}/api/token/refresh`;
    return await this.http.post(url, null, { params: { refreshToken }, skipInterceptor: true });
  }

  public async getRefToken(): Promise<RefTokenResponse> {
    const url = `${this.url}/api/token/refToken`;
    return await this.http.post(url);
  }  

}

export const authController = new AuthController({ url: env.origin });
